<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col class="page-title">
          WMDS
        </b-col>
      </b-row>

      <b-row v-if="!is_main">
        <b-col sm="6">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" />
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='name';so.skt='name'">이름</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='fqdn';so.skt='host'">Host</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <!-- <b-btn variant="outline-secondary"><i :class="'fa ' + (so.adv ? 'fa-search-minus' : 'fa-search-plus')"></i></b-btn> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <template slot="action" slot-scope="row">{{codes.agent_forgery[row.item.action] || "변경"}}</template>
        <template slot="target" slot-scope="row">{{row.item.target}}</template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
    </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
